import { render, staticRenderFns } from "./CommonWriteKwResult.vue?vue&type=template&id=1bc523f6&scoped=true"
import script from "./CommonWriteKwResult.vue?vue&type=script&lang=js"
export * from "./CommonWriteKwResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWriteKwResult.vue?vue&type=style&index=0&id=1bc523f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc523f6",
  null
  
)

export default component.exports